<template>
<div class="c-a-status-circle" :class="color"></div>
</template>

<script>
export default {
    props: {
        value: String
    },
    computed: {
        color: function() {
            return `c-a-status-circle--${this.value}`
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomStatusCircle.vue